import { render, staticRenderFns } from "./ViewActivityPage.vue?vue&type=template&id=5bbea458"
import script from "./ViewActivityPage.vue?vue&type=script&lang=js"
export * from "./ViewActivityPage.vue?vue&type=script&lang=js"
import style0 from "./ViewActivityPage.vue?vue&type=style&index=0&id=5bbea458&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports